import React, { useState } from 'react';
import styled from '@emotion/styled';
import { InfoOutlineIcon, Markdown } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import {
	Dialog,
	DialogHeader,
	DialogMain,
} from '../../../../../shared/components/dialog';
import { trackClickedExtrasMoreInfo } from '../../shared/analytics/custom/trackClickedExtrasMoreInfo';
import { Color } from '../../../../../shared/styles/Color';

export interface IMoreInformationProps {
	title?: string;
	text: string;
}

export const MoreInformation = ({ title, text }: IMoreInformationProps) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	const onClick = () => {
		trackClickedExtrasMoreInfo(title);
		setIsOpen(true);
	};

	const onClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			<Button
				onClick={onClick}
				type="button"
				aria-label={t('web_parking_extras_more_information_button_label')}
			>
				<InfoOutlineIcon variation="text" />
			</Button>
			{isOpen && (
				<Dialog
					ariaLabel={t('web_parking_extras_more_information_dialog_label')}
					onClose={onClose}
				>
					<DialogHeader>{title && <h3>{title}</h3>}</DialogHeader>
					<DialogMain wideContent>
						<Markdown source={text} />
					</DialogMain>
				</Dialog>
			)}
		</>
	);
};

const Button = styled.button`
	display: inline-block;
	margin-left: 16px;
	cursor: pointer;
	background-color: transparent;
	border: none;

	&:focus {
		outline: none;

		${InfoOutlineIcon} {
			outline: 2px solid ${Color.PrimaryDefault};
			box-shadow: 0 0 0 3px ${Color.AccentDefault};
			border-radius: 50%;
			opacity: 0.6;
		}
	}

	${InfoOutlineIcon} {
		transition: opacity 0.2s ease;
		opacity: 0.4;
	}

	&:hover {
		${InfoOutlineIcon} {
			opacity: 0.5;
		}
	}
`;
